export default "__VITE_ASSET__4db242d7__"